import { Injectable } from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store, TimeField } from "@bryntum/grid";
import { FormatString } from "../constant/format-string";
import dayjs from "dayjs";

@Injectable({
    providedIn: 'root'
})

/**
 * this will be used to create bryntum widgets
*/
export class BryntumWidgetBuilderService {
    static serviceName: string = 'bryntumWidgetBuilderService';

    initiateTimeField(appendTo: string, defaultValue: Date, formControl: FormControl, isTimeSpan: boolean = true): TimeField {
        const timefield = new TimeField({
            appendTo: appendTo,
            cls: 'create-input',
            value: defaultValue,
            height: '32px',
            picker: {
                items: {
                    minute: {
                        step: 15
                    }
                }
            },
            disabled: formControl.disabled,
            listeners: {
                change: (event: any) => {
                    if(isTimeSpan){
                        formControl.patchValue(dayjs(new Date(event.value)).format(FormatString.timeSpan));
                    } else {
                        formControl.patchValue(dayjs(new Date(event.value)).format(FormatString.bryntumDateTime24h()));
                    }
                    formControl.markAsDirty();
                }
            }
        });

        return timefield;
    }

    buildGridRowDeleteWidget(store: Store) {
        return {
            type: 'button',
            icon: 'b-fa-minus',
            cls: 'b-red b-raised',
            field: 'actions',
            onAction: ({ source, btn }: any) => {
                store.remove(source.cellInfo.record);
            }
        }
    }
}
